import React from 'react';

export default function useDebounceCallback(delay, callback) {
  const timeoutId = React.useRef();
  const lastCallback = React.useRef(callback);

  const debounce = React.useCallback(
    (...params) => {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }
      timeoutId.current = setTimeout(() => lastCallback.current(...params), delay);
    },
    [delay],
  );

  lastCallback.current = callback;

  return debounce;
}
